import { dayjs } from '@shared/utils';
import { z } from 'zod';

export const ExamResultFileFilterFormSchema = z
  .object({
    createdDateFrom: z
      .date()
      .nullable()
      .refine((val) => val !== null, {
        message: 'กรุณาเลือก Start Date',
      }),
    createdDateTo: z
      .date()
      .nullable()
      .refine((val) => val !== null, {
        message: 'กรุณาเลือก End Date',
      }),
  })
  .refine(
    (data) => {
      if (!data.createdDateFrom || !data.createdDateTo) {
        return true;
      }

      const from = dayjs(data.createdDateFrom);
      const to = dayjs(data.createdDateTo);

      return from.isSameOrBefore(to, 'day');
    },
    {
      message: 'End Date ต้องมากกว่าหรือเท่ากับ Start Date',
      path: ['createdDateTo'],
    },
  );

export type ExamResultFileFilterFormInput = z.input<typeof ExamResultFileFilterFormSchema>;

export type ExamResultFileFilterFormOutput = z.output<typeof ExamResultFileFilterFormSchema>;
